export default {"src":"/_next/static/media/ic-check.0628b714.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};